export default __webpack_public_path__ + "static/media/erp-app-development-service.5215dff0.png";